import { createFeature, createReducer, on } from '@ngrx/store'

import { AssignedPermissionSetsState } from './assigned-permissionsets.state'
import {
  createAssignedPermissionSets,
  createAssignedPermissionSetsFailure,
  createAssignedPermissionSetsSuccess,
  loadAssignedPermissionSets,
  loadAssignedPermissionSetsFailure,
  loadAssignedPermissionSetsSuccess,
  updateAssignedPermissionSets,
  updateAssignedPermissionSetsFailure,
  updateAssignedPermissionSetsSuccess
} from './assigned-permissionsets.actions'

export const initialState: AssignedPermissionSetsState = {
  totalCount: 0,
  assignedPermissionSets: null,
  loading: false,
  error: null
}

// Create the AssignedPermissionSets reducer
export const assignedPermissionSetsReducer = createReducer(
  initialState,
  on(loadAssignedPermissionSets, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadAssignedPermissionSetsSuccess, (state, { totalCount, assignedPermissionSets }) => ({
    ...state,
    totalCount,
    assignedPermissionSets,
    loading: false,
    error: null
  })),
  on(loadAssignedPermissionSetsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createAssignedPermissionSets, state => ({ ...state, loading: true })),
  on(createAssignedPermissionSetsSuccess, (state, { assignedPermissionSets }) => ({
    ...state,
    assignedPermissionSets,
    loading: false
  })),
  on(createAssignedPermissionSetsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateAssignedPermissionSets, state => ({ ...state, loading: true })),
  on(updateAssignedPermissionSetsSuccess, (state, { assignedPermissionSet }) => ({
    ...state,
    assignedPermissionSet,
    loading: false
  })),
  on(updateAssignedPermissionSetsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
)

// Create the feature for the AssignedPermissionSets state
export const assignedPermissionSetsFeature = createFeature({
  name: 'AssignedPermissionSets', // Feature name
  reducer: assignedPermissionSetsReducer
})
export type { AssignedPermissionSetsState }
// Export the feature's selectors
export const { name, reducer, selectAssignedPermissionSets, selectLoading, selectError } =
  assignedPermissionSetsFeature
